'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = profile;
exports.isLoaded = isLoaded;
exports.load = load;
exports.update = update;
exports.resetPassword = resetPassword;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOAD = 'LOAD';
var LOAD_SUCCESS = 'LOAD_SUCCESS';
var LOAD_FAIL = 'LOAD_FAIL';
var UPDATE = 'UPDATE';
var UPDATE_SUCCESS = 'UPDATE_SUCCESS';
var UPDATE_FAIL = 'UPDATE_FAIL';
var RESET_PASSWORD = 'RESET_PASSWORD';
var RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS';
var RESET_PASSWORD_FAIL = 'RESET_PASSWORD_FAIL';

var tempDate = new Date('2015/03/30').toISOString();
var initialState = {
  loaded: false,
  // TODO: remove TEMP FOR TESTING
  data: {
    childName: 'ChangeThis',
    childDOB: tempDate,
    childGender: 'Male'
  }
};

function profile() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case UPDATE:
    case LOAD:
      return (0, _extends3.default)({}, state, {
        loading: true
      });
    case UPDATE_SUCCESS:
    case LOAD_SUCCESS:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: true,
        data: action.result
      });
    case UPDATE_FAIL:
    case LOAD_FAIL:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: false,
        error: action.error
      });
    case RESET_PASSWORD:
      return (0, _extends3.default)({}, state, {
        loading: true
      });
    case RESET_PASSWORD_SUCCESS:
      return (0, _extends3.default)({}, state, {
        loading: false
      });
    case RESET_PASSWORD_FAIL:
      return (0, _extends3.default)({}, state, {
        loading: false,
        error: action.error
      });
    default:
      return state;
  }
}

function isLoaded(globalState) {
  return globalState.profile && globalState.profile.loaded;
}

function load(userId) {
  return {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    promise: function promise(client) {
      return client.get('/profile/load/', {
        params: {
          userId: userId
        }
      });
    }
  };
}

function update(userId, state) {
  return {
    types: [UPDATE, UPDATE_SUCCESS, UPDATE_FAIL],
    promise: function promise(client) {
      return client.post('/profile/update', {
        data: {
          userId: userId,
          state: state
        }
      });
    }
  };
}

function resetPassword(userId, newPassword) {
  return {
    types: [RESET_PASSWORD, RESET_PASSWORD_SUCCESS, RESET_PASSWORD_FAIL],
    promise: function promise(client) {
      return client.post('profile/resetPassword', {
        params: {
          userId: userId,
          password: newPassword
        }
      });
    }
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/profile.js
// module id = 163
// module chunks = 0